import { TeamSetupArea } from "nekst-api";
import { Dropdown, DropdownLayoutTheme } from "ui-builder";
import React from "react";

export function TeamSetupAreaCompactDropdown(
  props: {
    setupAreas: TeamSetupArea[],
    value?: number,
    onChangeCallback?: (value: number | null) => void,
    withAllMarketsOption?: boolean,
  }
) {
  if (props.setupAreas.length > 1) {
    return (
      <Dropdown
        source="setupAreaId"
        label="Choose Market"
        value={props.value}
        onChangeCallback={(value) => {
          props.onChangeCallback?.(value.setupAreaId)
        }}
        options={[
          ...props.withAllMarketsOption ?  [{
            value: null,
            label: 'All Markets',
          }] :[],
          ...props.setupAreas.map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ]}
        isClearable={false}
        hideLabel
        layoutTheme={DropdownLayoutTheme.COMPACT}
      />
    );
  } else {
    return null;
  }
}
